/**
 * /app/$tenantSlug/me/letters/$id — one letter, for its recipient
 * (wave-2 offboarding). Letter notifications and the delivery email link
 * here: view / download the PDF and, for a warning letter, acknowledge
 * receipt. Reachable in the restricted leaver session too.
 */

import { createFileRoute } from "@tanstack/react-router";
import { LetterRecipientView } from "@/components/offboarding/letter-recipient-view";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/me/letters/$id")({
  component: MyLetterRoute,
});

function MyLetterRoute() {
  const { id } = Route.useParams();
  return <LetterRecipientView letterId={id} />;
}
